"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _reactContentLoader = _interopRequireDefault(require("react-content-loader")),
    _vars = require("../../../common/styles/vars"),
    colorMap = {
  darkTheme: {
    primaryColor: _vars.COLOURS.grey.nevada,
    secondaryColor: _vars.COLOURS.grey.raspingSandy
  },
  lightTheme: {
    primaryColor: _vars.COLOURS.grey.athens.parthenon,
    secondaryColor: _vars.COLOURS.grey.sterling
  }
};

function getTheme(a, b) {
  var c = b.darkTheme;
  return a ? {
    primaryColor: _vars.FLATTENED_COLOURS[a.primaryColor],
    secondaryColor: _vars.FLATTENED_COLOURS[a.secondaryColor]
  } : c ? colorMap.darkTheme : colorMap.lightTheme;
}

function ContentLoaderWrapper(a) {
  var b = a.height,
      c = void 0 === b ? 140 : b,
      d = a.width,
      e = a.speed,
      f = void 0 === e ? 1.5 : e,
      g = a.darkTheme,
      h = a.children,
      i = a.customTheme,
      j = (0, _objectWithoutProperties2["default"])(a, ["height", "width", "speed", "darkTheme", "children", "customTheme"]),
      k = getTheme(i, {
    darkTheme: g
  }),
      l = k.primaryColor,
      m = k.secondaryColor;
  return _react["default"].createElement(_reactContentLoader["default"], (0, _extends2["default"])({
    height: c,
    width: d,
    speed: f,
    primaryColor: l,
    secondaryColor: m
  }, j), h);
}

var _default = (0, _react.memo)(ContentLoaderWrapper);

exports["default"] = _default;